const TOKEN = 'TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';

const setToken = (token) => {
  sessionStorage.setItem(TOKEN, token);
  sessionStorage.setItem(REFRESH_TOKEN, token);
};

const getAccessToken = () => {
  return sessionStorage.getItem(TOKEN);
};

const getRefreshToken = () => {
  return sessionStorage.getItem(REFRESH_TOKEN);
};

const clearToken = () => {
  sessionStorage.removeItem(TOKEN);
  sessionStorage.removeItem(REFRESH_TOKEN);
};

const output = {
  setToken,
  getAccessToken,
  getRefreshToken,
  clearToken,
};

export default output;
